<div *ngIf="show"
    class="login-msg"
    [style.top]="loginInfoTopValue">
    <div class="tip-icon">
        <svg class="icon">
            <use xlink:href="#icon-status-info"></use>
        </svg>
    </div>
    <div class="msg-content">
        <div *ngIf="loginInfo.last.show">
            <n-kv>
                <n-kv-item [key]="i18n.lastLoginTime">
                    {{ loginInfo.last.loginTime }}
                </n-kv-item>
                <n-kv-item [key]="i18n.lastLoginIP">
                    {{ loginInfo.last.loginIP }}
                </n-kv-item>
            </n-kv>
        </div>
        <div *ngIf="loginInfo.custom.show && !ShardSwitch.SHOW_CUSTOM_PROMPT"
            class="custom-info">
            <span>{{utilService.decodeHTML | fn :loginInfo.custom.content}}</span>
        </div>
    </div>
    <div class="close-btn" (click)="show=false;">
        <svg class="icon">
            <use xlink:href="#icon-close"></use>
        </svg>
    </div>
</div>
